import { Outlet } from "react-router-dom";
import Navigation from "../navBar";

const ThankYouLayout = () => {
  return (
    <>
      <div className="thank-you-laout">
        <Navigation />
        <Outlet />
      </div>
    </>
  )
};

export default ThankYouLayout;